// extracted by mini-css-extract-plugin
module.exports = {"breadcrumb":"C4nji","homeIcon":"juzuA"};